import React from 'react';
import MasterLayout from '../../components/MasterLayout';

const Parts = () => {
  const columns = [
    { key: 'part_no', label: 'Part No' },
    { key: 'name', label: 'Name' },
    { key: 'customers', label: 'Customer', render: (customers) => customers && customers.length > 0 ? customers[0].name : '-' },
    { key: 'part_weight', label: 'Part Weight (g)' },
    { key: 'hsn_code', label: 'HSN' },
    { key: 'tax_rate', label: 'Tax %' },
    { key: 'drawing_no', label: 'Drawing No' },
    { key: 'status', label: 'Status' },
  ];

  const formFields = [
    { name: 'part_no', label: 'Part No', required: true, placeholder: 'PRT001' },
    { name: 'name', label: 'Name', required: true, placeholder: 'Part Name' },
    {
      name: 'customer_id',
      label: 'Customer',
      required: true,
      type: 'related-select',
      relatedKey: 'customers',
      optionLabel: (c) => `${c.code} - ${c.name}`,
    },
    { name: 'description', label: 'Description', type: 'textarea', fullWidth: true },
    { name: 'part_weight', label: 'Part Weight (grams)', type: 'number', placeholder: '0.00' },
    { name: 'hsn_code', label: 'HSN Code', placeholder: 'HSN Code' },
    { name: 'tax_rate', label: 'Tax Rate (%)', type: 'number', placeholder: '18.00' },
    { name: 'drawing_no', label: 'Drawing No', placeholder: 'Drawing Number' },
    { name: 'revision', label: 'Revision', placeholder: 'Rev' },
    {
      name: 'status',
      label: 'Status',
      type: 'select',
      options: [
        { value: 'ACTIVE', label: 'Active' },
        { value: 'INACTIVE', label: 'Inactive' },
        { value: 'DEVELOPMENT', label: 'Development' },
        { value: 'DISCONTINUED', label: 'Discontinued' },
      ]
    },
  ];

  // When opening an existing part for edit, map customers[0].id → customer_id
  const initFormData = (item) => ({
    ...item,
    customer_id: item.customers && item.customers.length > 0 ? item.customers[0].id.toString() : '',
  });

  // Before submitting, convert single customer_id → customer_ids list (backend expects list)
  const transformSubmit = (data) => {
    const { customer_id, customers, ...rest } = data;
    return {
      ...rest,
      customer_ids: customer_id ? [parseInt(customer_id)] : [],
    };
  };

  return (
    <MasterLayout
      title="Parts"
      endpoint="parts"
      columns={columns}
      formFields={formFields}
      searchFields={['part_no', 'name']}
      permissions={['ADMIN', 'PRODUCTION']}
      useSlidePanel={true}
      relatedEndpoints={{ customers: 'customers' }}
      initFormData={initFormData}
      transformSubmit={transformSubmit}
    />
  );
};

export default Parts;
